import { useContext } from "react";
import { SupabaseContext } from "@/context/AuthProvider";
import { supabase as supabaseClient } from "@/lib/supabase";

export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error("useSupabase must be used within a SupabaseProvider");
  }
  return {
    ...context,
    supabase: supabaseClient
  };
};